import { SidebarTrigger } from '@eigtech/ui/components/sidebar'

export function TopToolbar() {
  return (
    <header className="flex h-16 shrink-0 items-center justify-between gap-2 bg-white shadow transition-[width,height] ease-linear">
      <div className="flex items-center gap-2 px-4">
        <SidebarTrigger className="-ml-1" />
      </div>
    </header>
  )
}
